import { takeLatest } from 'redux-saga/effects';
import {
    ADD_PETTY_CASH_REQUEST,
} from '../../redux/modules/pettyCash/pettyCash-actions';
import addPettyCash from './pettyCashWorker';

export default function* createPettyCash() {
    yield takeLatest(ADD_PETTY_CASH_REQUEST, addPettyCash);
}
